import React, {useContext, useMemo} from 'react';

import {GlobalTranslationsContext} from '../../i18n';

import SelectFilter, {SelectFilterProps} from './SelectFilter';

const TrueFalseFilter = <K extends string, T extends boolean, F extends Partial<Record<K, T>>>(
    selectProps: Omit<SelectFilterProps<K, T, F>, 'options'>
): JSX.Element => {
    const {general} = useContext(GlobalTranslationsContext);
    const options = useMemo(
        () => [
            {value: true, label: general.yes},
            {value: false, label: general.no},
        ],
        [general]
    );
    return (
        <SelectFilter
            {...selectProps}
            options={options}
        />
    );
};

export default TrueFalseFilter;
